import { render, staticRenderFns } from "./SidebarInviteUser.vue?vue&type=template&id=36ec2a51&"
import script from "./SidebarInviteUser.vue?vue&type=script&lang=js&"
export * from "./SidebarInviteUser.vue?vue&type=script&lang=js&"
import style0 from "./SidebarInviteUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports